import styled from "@emotion/styled/macro";
import React from "react";
import { Fragment } from "react";
import InfoCard from "./InfoCard";
import Rupees from "./Rupees";
import { getToFixedValue } from "Utils/index";

const BasicDetails = (props) => {
  const { details } = props;
  return (
    <Fragment>
      <BasicDetailsWrapper>
        <InfoCard headerLabel={"Basic Details"} />
        <InfoCard
          labelL1={"Rail Distance"}
          labelL2={`${details.distance} Km`}
          isActive={false}
        />
        <InfoCard
          headerLabel={false}
          labelL1={"Class"}
          labelL2={`${details.charged_rate_class}`}
          isActive={false}
        />
        <InfoCard
          headerLabel={false}
          labelL1={"Freight Rate per Tonne"}
          labelL2={<Rupees rate={`${details.freight_rate_per_ton}`} />}
          isActive={false}
        />
        <InfoCard
          headerLabel={false}
          labelL1={"Number of Wagon"}
          labelL2={`${details.wagon}`}
          isActive={false}
        />
        <InfoCard
          headerLabel={false}
          labelL1={"Std. Weight Per Wagon"}
          labelL2={`${details.pcc} MT`}
          isActive={false}
        />
        <InfoCard
          headerLabel={false}
          labelL1={"Loading Weight Per Wagon"}
          labelL2={`${details.loading_weight_wagon} MT`}
          isActive={false}
        />
        <InfoCard
          headerLabel={false}
          labelL1={"Loaded Weight"}
          labelL2={`${details.sender_weight} MT`}
          isActive={false}
        />
        <InfoCard
          headerLabel={false}
          labelL1={"Chargeable Weight"}
          labelL2={`${details.chargeable_weight} MT`}
          isActive={true}
        />
        <InfoCard
          headerLabel={false}
          labelL1={"Railway Receipt Amount"}
          labelL2={<Rupees rate={`${details.final_freight}`} />}
          isActive={true}
        />
        <InfoCard
          headerLabel={false}
          labelL1={"Per Wagon Charges"}
          labelL2={<Rupees rate={`${details.per_wagon_charges}`} />}
          isActive={false}
        />
        <InfoCard
          headerLabel={false}
          labelL1={"RailWay Freight Per MT"}
          labelL2={<Rupees rate={`${getToFixedValue(details.per_mt_freight,2)}`} />}
          isActive={false}
        />
      </BasicDetailsWrapper>
    </Fragment>
  );
};

export default BasicDetails;

const BasicDetailsWrapper = styled.div``;
